module.exports = __webpack_public_path__ + "static/media/33-1.c4b78a65.mp3";